import Spinner from 'react-bootstrap/Spinner';
import { AppHeader } from "./AppHeader";
import { useMemo, useState } from 'react';
import { AppFooter } from './AppFooter';
import { axiosGetWithHeader, ShowAlertError } from '../Common/axios';
import { AstrologerInfoFooter } from '../Common/AstrologerInfoFooter';
import { useLocation } from 'react-router-dom';
import { EventsMenu } from './EventsMenu';
import { EventAnalyser } from './Events/EventAnalyser';
import { ProsperityChart } from './Events/ProsperityChart';
import { TimeChart } from './Events/TimeChart';
import { DestinyAnalyser } from './Events/DestinyAnalyser';
import { AstrologerComment } from './Events/AstrologerComment';
import { KPPlanetSchedule } from './KPPage/KPPlanetSchedule';
import { BirthTimeCorrectionTab } from './Basic/BirthTimeCorrectionTab';

export function Events()  {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const [userData, setUserData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [eventData, setEventData] = useState([]);
  const [eventKey, setEventKey] = useState([0]);
  const [menuArray, setMenuArray] = useState([]);
  const [mainspinner, setMainSpinner] = useState('Loading - Event Analyser Page');
  const [errorAlert, setErrorAlert] = useState(null);

  function handleMenu(menuArray){
    setMenuArray(menuArray)
  }

  function handleEventKey(eventKey){
    setEventKey(eventKey)
  }

  useMemo(() => {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getClientData(response.data.id);
        getEventData(response.data.id,eventKey);
        setMainSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setMainSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }, [runningId,eventKey]);

  function getUserRequest(runningId) {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        getClientData(response.data.id);
        getEventData(response.data.id,eventKey);
        setMainSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setMainSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
  }

  function getClientData(clientId) {
    axiosGetWithHeader("/chart/userdata/"+clientId,
      (response)=>{
        setClientData(response.data);
      },
      (error)=>{
        console.log(error);
        setClientData(null);
        setErrorAlert(error.message);
      }
    );
  }

  function getEventData(clientId,eventKey) {
    axiosGetWithHeader("/chart/event/"+clientId+"/"+eventKey,
      (response)=>{
        setEventData(response.data);
        setEventKey(response.data.currentEvent.id);
      },
      (error)=>{
        console.log(error);
        setEventData(null);
        setErrorAlert(error.message);
      }
    );
  }
    
  return (<>
    <div class="m-0 p-0 row sticky-top bg-white noprint">
      <div class="m-0 p-0 col-sm-12 col-md-12">
        <AppHeader/>
        <EventsMenu userData={userData} clientData={clientData} handleMenu={handleMenu} />
      </div>    
    </div>
    {mainspinner===null?<></>:<>{mainspinner} <Spinner animation="border" size="sm" /></>}
    { userData===null||userData===undefined||clientData===null||clientData===undefined
      ||eventData===null||eventData===undefined||eventData.currentEvent===null||eventData.currentEvent===undefined?<></>:<>
      <div class="m-0 p-0 row align-items-top content">
        <div class="m-0 p-0 col-sm-12 col-md-12">
          <div class="menupageheight">
            <EventAnalyser menuArray={menuArray} userData={userData} clientData={clientData} eventData={eventData} handleEventKey={handleEventKey} handleEventData={getEventData}/>
            <DestinyAnalyser menuArray={menuArray} userData={userData} clientData={clientData} eventData={eventData} handleEventKey={handleEventKey} handleEventData={getEventData}/>
            <ProsperityChart menuArray={menuArray} userData={userData} clientData={clientData} eventData={eventData} handleEventKey={handleEventKey} handleEventData={getEventData}/>
            <TimeChart menuArray={menuArray} userData={userData} clientData={clientData} eventData={eventData} handleEventKey={handleEventKey} handleEventData={getEventData} />
            <KPPlanetSchedule menuArray={menuArray} userData={userData} clientData={clientData} setErrorAlert={setErrorAlert}/>
            <AstrologerComment menuArray={menuArray} userData={userData} clientData={clientData} eventData={eventData} handleEventKey={handleEventKey} handleEventData={getEventData} setErrorAlert={setErrorAlert}/>
            <BirthTimeCorrectionTab menuArray={menuArray} menuIndex="5" userData={userData} getUserRequest={getUserRequest} />
          </div>  
        </div>
      </div>
      </>
    }
    <div class="m-0 p-0 row noprint">
      <div class="m-0 p-0 col-sm-12 col-md-12">
        <AppFooter/>
      </div>    
    </div>
    { userData===null||userData===undefined?<></>:
      <div class="m-0 p-0 row d-none d-print-block printfooter">
        <div class="m-0 p-0 col-sm-12 col-md-12">
          <AstrologerInfoFooter userData={userData}  />
        </div>    
      </div>
    } 
    <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
  </>
  );
}